import { InfoPageTableCol } from './InfoPageTableCol.style';

export default InfoPageTableCol;
